import { render } from "./feature-list.vue?vue&type=template&id=39c0f0d6&scoped=true"
import script from "./feature-list.vue?vue&type=script&lang=js"
export * from "./feature-list.vue?vue&type=script&lang=js"

import "./feature-list.vue?vue&type=style&index=0&id=39c0f0d6&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39c0f0d6"]])

export default __exports__